import './style.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('catalog-filter-single', () => import(/* webpackMode: "lazy" */'./catalog-filter-single'));
